import { createContext, useContext } from 'react';

// Eén globale brochure-modal (gemount in AppShell via BrochureProvider), zodat
// elke pagina, de footer en de contactpagina dezelfde leadcapture gebruiken.
export type BrochureContextValue = { openBrochure: () => void };

export const BrochureContext = createContext<BrochureContextValue>({
  openBrochure: () => {},
});

export function useBrochure() {
  return useContext(BrochureContext);
}
